var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "posts" }, [
    _c(
      "a",
      {
        staticClass: "logo",
        attrs: { href: _vm.downloadLink },
        on: { click: _vm.logoDownloadEvent },
      },
      [_c("img", { attrs: { src: "/public/logo_v2.png" } })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "bg-gray clear" }, [
      _c("div", { staticClass: "content clear" }, [
        _c("img", {
          staticClass: "avatar",
          attrs: { src: _vm.posts.post.creator.avatarUrl },
        }),
        _vm._v(" "),
        _c("h2", [_vm._v(_vm._s(_vm.posts.post.creator.firstName))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.posts.post.description))]),
        _vm._v(" "),
        _vm.posts.post.images !== undefined && _vm.posts.post.images.length > 0
          ? _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: _vm.posts.post.images[0].fileUrl } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.posts.post.videos !== undefined && _vm.posts.post.videos.length > 0
          ? _c("div", { staticClass: "video" }, [
              _c(
                "video",
                {
                  attrs: {
                    width: "265",
                    src: _vm.posts.post.videos[0].fileUrl,
                    controls: "controls",
                  },
                },
                [_vm._v("您的浏览器不支持 video 标签。")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "meta" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.posts.post.likeCount) +
              " likes, " +
              _vm._s(_vm.posts.post.commentCount) +
              " comments\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn-get-app",
          attrs: { href: _vm.downloadLink },
          on: { click: _vm.buttonDownloadEvent },
        },
        [_c("img", { attrs: { src: "/public/get_the_lmk_app@2x.png" } })]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips clear" }, [
      _c("p", [_vm._v("👻🔥👇")]),
      _vm._v(" "),
      _c("p", [_vm._v("Share your life.")]),
      _vm._v(" "),
      _c("p", [_vm._v("Make new friends!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Post.vue